import { type GalleryAnalytics } from "../../lib/api";

interface GalleryStatsTabProps {
  analytics: GalleryAnalytics | null;
  loading: boolean;
}

export function GalleryStatsTab({ analytics, loading }: GalleryStatsTabProps) {
  if (loading) return <p style={{ color: "var(--muted)" }}>Loading stats…</p>;
  if (!analytics) return (
    <div className="card">
      <p style={{ margin: 0, color: "var(--muted)" }}>No analytics data yet. Share your gallery to start collecting views.</p>
    </div>
  );
  const maxViews = Math.max(...analytics.views_by_day.map((d) => d.count), 1);
  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: "1rem", marginBottom: "1.5rem" }}>
        <div className="card" style={{ textAlign: "center", padding: "1rem" }}>
          <div style={{ fontSize: "1.75rem", fontWeight: 700, color: "var(--accent, #10b981)" }}>{analytics.total_views}</div>
          <div style={{ color: "var(--muted)", fontSize: "0.8rem" }}>Total views</div>
        </div>
        <div className="card" style={{ textAlign: "center", padding: "1rem" }}>
          <div style={{ fontSize: "1.75rem", fontWeight: 700, color: "var(--accent, #10b981)" }}>{analytics.unique_viewers}</div>
          <div style={{ color: "var(--muted)", fontSize: "0.8rem" }}>Unique viewers</div>
        </div>
        <div className="card" style={{ textAlign: "center", padding: "1rem" }}>
          <div style={{ fontSize: "1.75rem", fontWeight: 700, color: "var(--accent, #10b981)" }}>{analytics.total_downloads}</div>
          <div style={{ color: "var(--muted)", fontSize: "0.8rem" }}>Downloads</div>
        </div>
      </div>
      {analytics.views_by_day.length > 0 && (
        <div className="card">
          <p style={{ margin: "0 0 0.75rem", fontSize: "0.85rem", color: "var(--muted)", fontWeight: 600 }}>Views trend</p>
          <div style={{ display: "flex", gap: "2px", height: "60px", alignItems: "flex-end" }}>
            {analytics.views_by_day.map((d) => (
              <div
                key={d.date}
                title={`${d.date}: ${d.count} views`}
                style={{
                  flex: 1,
                  background: "var(--accent, #10b981)",
                  borderRadius: "2px 2px 0 0",
                  height: `${Math.round((d.count / maxViews) * 100)}%`,
                  minHeight: d.count > 0 ? 4 : 0,
                }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

